import axios from 'axios'

export default class GrauCooperativa {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/dominios/grauCooperativa`
    this.tokenBearer = tokenBearer
  }

  getGrauCooperativa () {
    return new Promise(async (resolve, reject) => {
      let optionsGrauCooperativa = {
        method: 'get',
        url: `${this.url}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseGrauCooperativa = await axios(optionsGrauCooperativa)
        resolve(responseGrauCooperativa)
      } catch (err) {
        reject(err)
      }
    })
  }
}
